import { QuotationService } from 'app/services/quotation.service';
import { ModelPathEnum } from 'app/shared/enums';
import { getQuotation } from 'app/services/businessFunctionHelpers';

export function updatePersonalDataPathFromCheckout() {
  const { mainOwner, coOwners, id, personalDataPath } = getQuotation();

  const mainOwnerIsNotFill =
    !mainOwner?.name && !mainOwner?.lastName && !mainOwner?.peselNumber;

  const firstCoownerIsNotFill =
    coOwners &&
    !coOwners[0]?.name &&
    !coOwners[0]?.lastName &&
    !coOwners[0]?.peselNumber;

  const secondCoownerIsNotFill =
    coOwners &&
    !coOwners[1]?.name &&
    !coOwners[1]?.lastName &&
    !coOwners[1]?.peselNumber;

  if (
    !personalDataPath &&
    mainOwnerIsNotFill &&
    firstCoownerIsNotFill &&
    secondCoownerIsNotFill
  ) {
    QuotationService.update(id, ModelPathEnum.PersonalDataPath, true);
  }
}
